<div class="adx-lib-widget-view-wrapper">
  <div #contactWidgetContainer class="adx-contact-widget">
    <!-- Search Bar -->
    <div class="adx-search-container">
      <mat-form-field appearance="outline" class="adx-search-field">
        <i class="fas fa-search" matPrefix aria-hidden="true"></i>
        <input
          matInput
          placeholder="{{'ASTIMAX.CONTACT.WIDGET.SEARCH_CONTACTS' | translate }}..."
          [ngModel]="searchTerm()"
          (input)="onSearchChange($event)"
          aria-label="Search contacts"
          role="searchbox">
        </mat-form-field>
      </div>

      <!-- Tabs with New Group Button -->
      <div class="adx-tabs-container">
        <mat-tab-group
          class="adx-contact-tabs"
          mat-stretch-tabs="false"
          [selectedIndex]="selectedTabIndex()"
          (selectedIndexChange)="selectedTabIndex.set($event)"
          animationDuration="200ms">

          @for (group of contactGroups(); track group.groupId) {
            <mat-tab [label]="group.name" [attr.aria-label]="group.name + ' contacts group'">
              <ng-template mat-tab-label>
                <div class="adx-tab-label-container adx-hoverable">
                  <span class="adx-tab-label-text">{{ group.name }}</span>
                  @if (widgetPermissions.widgetSettingsEditEnabled) {
                    <button mat-icon-button
                      class="primary adx-edit-button adx-hover-edit"
                      (click)="editContactGroup($event, group)"
                      [attr.aria-label]="'Edit ' + group.name + ' group'"
                      matTooltip="{{'ASTIMAX.CONTACT.WIDGET.EDIT_CONTACT_GROUP' | translate }}">
                      <i class="fas fa-pen" aria-hidden="true"></i>
                    </button>
                  }
                </div>
              </ng-template>
              <div class="adx-tab-content">
                <!-- Contact List -->
                <mat-list class="adx-contact-list" role="list">
                  @for (contact of getFilteredContactsForGroup(group.groupId); track contact.contactId + contact.source) {
                    <mat-list-item
                      class="adx-contact-item"
                      [class.active]="true"
                      [class.manual-contact]="ContactUtils.isManualContact(contact)"
                      [class.extension-contact]="ContactUtils.isExtensionContact(contact)"
                      [class.external-contact]="ContactUtils.isExternalContact(contact)"
                      role="listitem"
                      [attr.aria-label]="ContactUtils.getContactAriaLabel(contact)"
                      tabindex="0"
                      (click)="initiateCall(contact)"
                      (keydown.enter)="initiateCall(contact)"
                      (keydown.space)="initiateCall(contact)">

                      <!-- Avatar with Status -->
                      <div class="adx-contact-avatar" matListItemAvatar>
                        <div class="adx-avatar-circle"
                          [attr.aria-label]="contact.name + ' avatar'">
                          @if (contact.avatar) {
                            <img [src]="contact.avatar"
                              [alt]="contact.name"
                              class="adx-avatar-image"
                              (error)="onAvatarError(contact)">
                            } @else {
                              {{ contact.initials || ContactUtils.getInitials(contact.name) }}
                            }
                          </div>

                          <!-- Status indicator only for extension contacts -->
                          @if (ContactUtils.isExtensionContact(contact)) {
                            <div class="adx-status-indicator"
                              [class]="'status-' + ContactUtils.getStatusClass(ContactUtils.getExtensionStatus(contact))"
                              [attr.aria-label]="ContactUtils.getStatusText(ContactUtils.getExtensionStatus(contact))">
                            </div>
                          } @else {
                            <div class="adx-status-indicator"
                              [class]="'status-' + ContactUtils.getStatusClass(undefined)"
                              [attr.aria-label]="ContactUtils.getStatusText(undefined)">
                            </div>
                          }

                          <!-- Source indicator for all contacts -->
                          <!--<div class="adx-source-indicator"
                          [attr.title]="ContactUtils.getContactSourceLabel(contact.source, translate)"
                          matTooltip="{{ ContactUtils.getContactSourceLabel(contact.source, translate) }}">
                          <i [class]="ContactUtils.getContactSourceIcon(contact)" aria-hidden="true"></i>
                        </div>-->
                      </div>

                      <!-- Contact Info -->
                      <div class="adx-contact-info" matListItemTitle>
                        <div class="adx-contact-header">
                          <div class="adx-contact-name">{{ contact.name }}</div>
                          @if (ContactUtils.isExtensionContact(contact) && ContactUtils.isInPause(contact)) {
                            <span [class]="ContactUtils.getExtensionContactStatusIconColor(contact)">
                              <i class="fas fa-pause" aria-hidden="true"></i>
                            </span>
                          }

                          @if (ContactUtils.isExtensionContact(contact) && ContactUtils.holdingCall(contact)) {
                            <span [class]="ContactUtils.getExtensionContactStatusIconColor(contact)" class="adx-hold-icon-group">
                               <i class="fas fa-phone adx-hold-phone" aria-hidden="true"></i>
                               <i class="fas fa-pause adx-hold-pause" aria-hidden="true"></i>
                            </span>
                          }

                          @if (ContactUtils.isExtensionContact(contact) && ContactUtils.callMonitoring(contact)) {
                            <span [class]="ContactUtils.getExtensionContactStatusIconColor(contact)">
                              <i class="fas fa-ear-listen" aria-hidden="true"></i>
                            </span>
                          }

                          @if (ContactUtils.isExtensionContact(contact) && ContactUtils.callRecording(contact)) {
                            <span [class]="ContactUtils.getExtensionContactStatusIconColor(contact)">
                              <i class="fas fa-microphone-lines" aria-hidden="true"></i>
                            </span>
                          }
                          <!--<div class="adx-contact-source-info" aria-label="Contact source">
                          {{ ContactUtils.getContactSourceLabel(contact.source, translate) }}
                        </div>-->
                      </div>
                      <div class="adx-contact-status-line">
                        <span class="adx-extension">[{{ ContactUtils.getDisplayPhoneNumber(contact) }}]</span>
                        <span class="adx-call-party-info">
                          @if (ContactUtils.isExtensionContact(contact) && ContactUtils.isInConference(contact)) {
                            <i class="fas fa-circle-nodes adx-icon-size" aria-hidden="true"></i>
                            {{ 'ASTIMAX.CONTACT.WIDGET.IN_CONFERENCE' | translate }}
                          }
                          @if (ContactUtils.isExtensionContact(contact) && ContactUtils.hasCallParty(contact) && ContactUtils.hasCallParties(contact) && !ContactUtils.isInConference(contact)) {
                            <i class="fas fa-phone adx-icon-size" aria-hidden="true"></i>
                            {{ ContactUtils.getFirstCallParty(contact)?.name }} {{ ContactUtils.getFirstCallParty(contact)?.number }}
                          }
                        </span>
                      </div>

                      <!-- Source info third row  -->
                      <!--<div class="adx-contact-source" aria-label="Contact source">
                      {{ ContactUtils.getContactSourceLabel(contact.source, translate) }}
                    </div>-->
                  </div>

                  <!-- Actions Menu -->
                  <div class="adx-contact-actions" matListItemMeta>
                      @if (canTransferToContact(contact) && !ContactUtils.isBusy(contact)) {
                          <button mat-icon-button
                                  class="direct-action-btn"
                                  (click)="transferCall(contact); $event.stopPropagation()"
                                  matTooltip="{{ 'ASTIMAX.CONTACT.WIDGET.TRANSFER_CALL' | translate }}">
                              <i class="fas fa-arrow-turn-up adx-transfer-icon adx-rotate-90" aria-hidden="true"></i>
                          </button>
                      } @else if (ContactUtils.isExtensionContact(contact) && !ContactUtils.isBusy(contact)) {
                          <button mat-icon-button
                                  class="direct-action-btn"
                                  (click)="initiateCall(contact); $event.stopPropagation()"
                                  matTooltip="{{ 'ASTIMAX.CONTACT.WIDGET.CALL' | translate }}">
                              <i class="fas fa-phone adx-init-call-icon" aria-hidden="true"></i>
                          </button>
                      }

                    <!-- Menu button (only visible on mobile when multiple actions exist) -->
                    <!--<button mat-icon-button
                    class="menu-action-btn"
                    [class.show-menu]="getContactActions(contact).length > 1"
                    [matMenuTriggerFor]="contactMenu"
                    [attr.aria-label]="'Actions for ' + contact.name"
                    matTooltip="{{ 'ASTIMAX.CONTACT.WIDGET.LIST_OF_ACTIONS' | translate }}"
                    (click)="$event.stopPropagation()">
                    <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                  </button>

                  <mat-menu class="contact-menu" #contactMenu="matMenu">
                    <button mat-menu-item (click)="initiateCall(contact)">
                      <i class="fas fa-phone adx-contact-menu-item-icon" aria-hidden="true"></i>
                      <span>{{ 'ASTIMAX.CONTACT.WIDGET.CALL' | translate }}</span>
                    </button>
                  </mat-menu>-->
                </div>

                <!-- Call Info (for active calls - extension contacts only) -->
                <!--@if (ContactUtils.shouldShowCallInfo(contact)) {
                <div class="adx-call-info" matListItemMeta>
                  @if (contact?.callDuration) {
                    <div class="adx-call-duration" aria-label="Call duration">{{ contact.callDuration }}</div>
                  }
                  @if (contact?.signalStrength) {
                    <div class="adx-signal-strength" [attr.aria-label]="'Signal strength: ' + contact.signalStrength + '%'">
                      <i class="fas fa-signal adx-signal-icon" aria-hidden="true"></i>
                      <span>{{ contact.signalStrength }}%</span>
                    </div>
                  }
                </div>
                }-->

                <!-- Last Activity (extension contacts only) -->
                <!--@if (ContactUtils.shouldShowLastActivity(contact)) {
                <div class="adx-last-activity" matListItemMeta aria-label="Last activity">
                  {{ contact.lastActivity }}
                </div>
                }-->
              </mat-list-item>
            }
          </mat-list>

          <!-- Empty State -->
          @if (getFilteredContactsForGroup(group.groupId).length === 0) {
            <div class="adx-empty-state" role="status" aria-live="polite">
              <i class="fas fa-search adx-empty-icon" aria-hidden="true"></i>
              <p>{{ 'ASTIMAX.CONTACT.WIDGET.NO_CONTACTS_FOUND' | translate }}</p>
              @if (searchTerm()) {
                <p class="adx-empty-subtitle">{{ 'ASTIMAX.CONTACT.WIDGET.HELP_TEXT_SEARCH_EMPTY_CONTACT_GROUP' | translate }}</p>
              } @else if (group.contacts.length === 0) {
                <p class="adx-empty-subtitle">{{ 'ASTIMAX.CONTACT.WIDGET.HELP_TEXT_EMPTY_CONTACT_GROUP' | translate }}</p>
              }
            </div>
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>

  <!-- New Group Button positioned next to tabs -->
  @if (widgetPermissions.widgetSettingsEditEnabled) {
    <button
      mat-raised-button
      class="adx-new-group-btn primary"
      (click)="openNewGroupDialog()"
      aria-label="Create new contact group"
      matTooltip="{{ 'ASTIMAX.CONTACT.WIDGET.CREATE_NEW_CONTACT_GROUP' | translate }}">
      <i class="fas fa-plus" aria-hidden="true"></i>
    </button>
  }
</div>
</div>
</div>
